import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import * as styles from './styles.css';

export const ModalLoader: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div data-testid="loader" className={styles['wrapper']}>
      <Spinner size={16} />
    </div>
  );
};

ModalLoader.displayName = 'ModalLoader';
